// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {useDispatch, useSelector} from 'react-redux';
import analytics from 'util/analytics';
import "./ClassCheckout.scss";
import Section from "./Section";
import { getClassCheckout } from 'util/api/CheckoutAPI'
import { useAuth } from 'util/auth'
import {useLocation, Link} from 'util/router'
import OfferingSelector from 'components/OfferingSelector'
import {LoginSignupForm} from 'components/AccountButton'
import { view } from 'react-dom-factories';
import Modal from 'react-bootstrap/Modal'
import { checkoutClass } from 'util/api/CheckoutAPI'
import CardSection from 'components/CardSection'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import PaymentMethodSelector from 'components/PaymentMethodSelector'
import CheckoutPricingSection from 'components/CheckoutPricingSection'
import ClassLocationSection from 'components/ClassLocationSection'
import PreviewImage from 'components/PreviewImage'
import {sendNewError} from 'util/slackbot'
import {insertReservation} from 'store/actions/userActions'
import {calculateDiscountFrom} from 'components/CheckoutPricingSection'
import Image from 'react-bootstrap/Image';
import { SET_WIDGET_STRIPE_ACCOUNT } from 'store/reducers/widgetReducer'
import {useWidget} from 'util/widget'
import { useForm, useFieldArray } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";

var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 
// import ReactPixel from 'react-facebook-pixel';

function deepEqual(object1, object2) {
    if (!object1 && !object2) {
        return true
    }
    if (!object1 && object2) {
        return false
    } else if (object1 && !object2) {
        return false
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if (
        areObjects && !deepEqual(val1, val2) ||
        !areObjects && val1 !== val2
      ) {
        return false;
      }
    }
  
    return true;
  }
  
  function isObject(object) {
    return object != null && typeof object === 'object';
  }


export function CustomFormFields({formResponse, handleUpdate}) {

    const { register, control, handleSubmit, setValue, formState, errors, dirty, getValues, watch } = useForm({
        defaultValues: {
            formFields: formResponse.fields.map(val => {
                return {
                    question: val.question,
                    answer: ""
                }
            })
        }
    });

    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control,
        name: "formFields"
    });

    const formFields = watch('formFields', fields)

    const [oldFormField, setOldFormField] = React.useState(null)

    useEffect(() => {

        if (handleUpdate && !deepEqual(oldFormField, formFields)) {
            setOldFormField(formFields)
            handleUpdate({
                id: formResponse.id,
                response: formFields
            })
            console.log(formFields)
        }
    },[formFields])

    // console.log("FORM FIELDS: ", formFields)
    // console.log("FORM FIELDS: ", fields)


    return (
    <>
        {formResponse.fields.map((val, index) => {
            return (
                <div key={index} className="form-group">
                    <label for="exampleInputEmail1">{val.question}</label>
                    <input className="d-none" name={`formFields[${index}].question`} type="text" ref={register} value={val.question} /> 
                    {val.size === 'sm' ? (
                        <input name={`formFields[${index}].answer`} ref={register({required: val.required ?? false})} type="text" class="form-control" id={"exampleInputEmail" + index} aria-describedby="emailHelp" />
                    ) : (
                        <textarea class="form-control" name={`formFields[${index}].answer`} id={"w3review" + index} ref={register({required: val.required ?? false})} rows="4" cols="50">
                        </textarea>
                    )}
                    
                    {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                </div>
            )
        })}
        <DevTool control={control} />
    </>
    )
}

function ClassCheckout(props) {

    const {ondemand} = props

    const auth = useAuth()
    const stripe = useStripe()
    const elements = useElements()
    const dispatch = useDispatch()
    const widget = useWidget()
    // const [runningtotal, setrunningtotal] = useState(0);
    const [takeonfee, settakeonfee] = useState(true);
    const [marketingEmails, setMarketingEmails] = useState(true);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const stripeAccountId = useSelector(state => state.widget.stripeAccount)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const classID = props.match.params.platformID

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today]',
            nextDay : '[Tomorrow]',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    const [serverSelectedClass, setServerSelectedClass] = React.useState(null)
    let listedSelectedClass = useSelector(state => ondemand ? 
        state.widget.onDemands.find(val => val.platformID === classID)
        : state.widget.classes.find(val => val.platformID === classID));

    const selectedClass = listedSelectedClass ? listedSelectedClass : serverSelectedClass
    const selectedInstructor = useSelector(state => state.widget.instructor);
    const reservations = useSelector(state => state.user.reservations)
    const reservationsMap = reservations.reduce((map, obj)=> {
        if (obj.serverReservationObjectId && !obj.canceled) {
            map[obj.serverReservationObjectId] = obj
        }
        return map
    },{})
    // const class_name = selectedClass ? selectedClass.class_name : "" 
    // const { class_name } = selectedClass ? selectedClass : null;
    useEffect(() => {
        analytics.page({
            title: 'Class Checkout'
        })
        analytics.track("Pre Purchase Viewed", {...selectedClass})
    }, [selectedClass])

    const [checkoutModel, setCheckoutModel] = React.useState({}) // JARCH: drop-in, class pack, etc.. 
    const [userCouponCode, setUserCouponCode] = React.useState(null)
    const handleCouponCodeChange = (couponCode) => {
        setUserCouponCode(couponCode)
    }
    const handleCouponCodeApply = () => {
        setIsLoading(true)
        getClassCheckout(classID, userCouponCode, widget.widgetName)
            .then(data => {
                setIsLoading(false)
                if (data.success) {
                    console.log("coupon code data: ", data)
                    setCheckoutData(data)
                }
                if (data.class) {
                    setServerSelectedClass(data.class)
                }
            })
            .catch(err => {
                console.log("standard checkout error: ", err)
                setIsLoading(false)
                // window.alert("Error fetching checkout. Please refresh the page.")
            })
    }
    const [checkoutData, setCheckoutData] = React.useState(null) // data from checkout
    useEffect(() => {
        if (!widget?.widgetName) {
            return
        }
        setIsLoading(true)
        getClassCheckout(classID, userCouponCode, widget.widgetName)
            .then(data => {
                setIsLoading(false)
                if (data.success) {
                    console.log("standard checkout data: ", data)
                    setCheckoutData(data)
                }
                if (data.class) {
                    setServerSelectedClass(data.class)
                }
                console.log("stripeAccount: ", data.stripeAccount)
                dispatch({type: SET_WIDGET_STRIPE_ACCOUNT, stripeAccount: data?.stripeAccount})
            })
            .catch(err => {
                console.log("standard checkout error: ", err)
                setIsLoading(false)
                // window.alert("Error fetching checkout. Please refresh the page.")
            })
    }, [auth?.userData, widget?.widgetName])

    var viewModel = {}
    var extraDescription = (<span></span>)
    const ownedOfferings = useSelector(state => state.user.ownedOfferings)
    const ownedChallenges = useSelector(state => state.user.ownedChallenges)
    if (selectedClass) {

        let location = "";
        switch (selectedClass.location_type) {
        case "inperson":
            location = selectedClass.location?.cityState ?? "In-Person"
            // location = selectedClass.location?.address ?? "In-Person"
            break
        default:
            location = "LIVESTREAM"
            break
        }
        // console.log("selected class: ", selectedClass)
        // let calculatedFeeString = formatter.format(calculatedFee)
        // let runningtotalstring = formatter.format(runningTotal)
        let isFree = (selectedClass.price === 0 && !selectedClass.isDonation && selectedClass.purchase_type?.toLowerCase() !== 'donation')
        selectedClass.isDonation = (selectedClass.purchase_type || "").toLowerCase() === "donation" || selectedClass.isDonation
        var isFull = false
        var spotsLeft = 999
        if (selectedClass.max_capacity && selectedClass.total_booked) {
            spotsLeft = selectedClass.max_capacity - selectedClass.total_booked
            if (selectedClass.total_booked >= selectedClass.max_capacity) {
                isFull = true
            }
        }
        var spotsLeftText = ""
        if (spotsLeft === 0) {
            spotsLeftText = "Full"
        } else if (spotsLeft === 1) {
            spotsLeftText = "1 spot left"
        } else {
            spotsLeftText = `${spotsLeft} spots left`
        }

        if (selectedClass?.instructor_id === 'XS5S7T9KRFPR3gBo5KwGdun6P4J2') {
            spotsLeftText = ""
        }

        var selectedPrice = checkoutModel.payment
        const discount = calculateDiscountFrom(checkoutModel, checkoutData?.couponCodeResponse)
        if (discount) {
            selectedPrice = selectedPrice - discount
        }

        const requirePayment = ((selectedPrice ?? 0) > 0) || checkoutModel.type === 'subscription'
        
        viewModel = {
            isFull: isFull,
            spotsLeft: spotsLeft,
            spotsLeftText: spotsLeftText,
            platformID: selectedClass.platformID,
            name: selectedClass.name || selectedClass.class_name || "Class",
            timeString: moment(selectedClass.start_time * 1000).format("ddd MMM Do • h:mma - ") + moment((selectedClass.start_time + (selectedClass.duration * 60)) * 1000).format("h:mma") + ` ${moment.tz(moment.tz.guess()).format('z')}`,
            image: (selectedClass.images && selectedClass.images.length > 0) ? selectedClass.images[0] : "",
            instructorName: selectedClass?.hostName,
            partnerName: selectedInstructor?.instructorProfile?.pageName,
            // location: selectedClass.location?.cityState ?? "LIVESTREAM",
            location: (["XS5S7T9KRFPR3gBo5KwGdun6P4J2", "TSu6fLqAkaboNwQ3Sb90wHlKfre2"].includes(selectedClass?.instructor_id)) ? (selectedClass.location?.address ?? "LIVESTREAM") : (selectedClass.location?.cityState ?? "LIVESTREAM"),
            description: selectedClass.description ?? selectedClass.class_about ?? "",
            priceText: selectedClass?.purchase_type?.toLowerCase() === 'donation' ? "Sliding scale" : (isFree ? "" : currencyFormatter.format(selectedClass.price)),
            takeonfee: takeonfee,
            marketingOptIn: marketingEmails,
            agreeToTerms: agreeToTerms,
            showPayment: requirePayment,
            nextbuttonstring: requirePayment ? "Purchase & Reserve" : "Reserve my spot",
            // showPayment: (checkoutModel?.payment ?? 0) > 0,
            // nextbuttonstring: ((checkoutModel?.payment ?? 0) > 0) ? "Purchase & Reserve" : "Reserve my spot",
            // showPayment: ((selectedPrice ?? 0) > 0) || checkoutModel.type === 'subscription',
            // nextbuttonstring: ((selectedPrice ?? 0) > 0) ? "Purchase & Reserve" : "Reserve my spot",
            showMarketingOptIn: checkoutData?.showMarketingOptIn,
            userCouponCode: userCouponCode,
            formResponse: checkoutData?.formResponse,
            allowsBooking: selectedClass ? moment(selectedClass.start_time * 1000).add(selectedClass.duration, 'm').unix() > moment().unix()  : false
        }

        if (checkoutData?.requiresWaiver) {
            viewModel.liabilityWaiverText = selectedInstructor?.instructorProfile?.liabilityWaiverTextHTML ?? selectedInstructor?.instructorProfile?.liabilityWaiverText
        }

        const cantreservetheseclasses = ["Qks5jmZFhZMWJZwqqNMo","iuCUcdcDYnT3HVJs8Jw5","N45MGphdqLTrgftu19hD","LTsdwq9FMGVmeFbfotYy","tTorLTUY9JOWQnhthSq4","64bPKumVuUJqSkw9AqYi","Ck1Jlcors4akEJWWYAIP","ASNzfS5UByiUgleQTtpV","TeaoTfXYDTG2Yw9fq2Gi","RQlT0W346ijIqKQ3MjIG","ha2RLMqxlwGHQDhZcdxm","3wewQYeqCDzw2sCdta07","OknNWRb9TK2T6ZmkLCe4","mA1uZxiTs0B31607c485"
        ]
        if (cantreservetheseclasses.includes(selectedClass.id) || isFull) {
            viewModel.nextbuttonstring = "Class is Full"
            viewModel.disableCheckout = true
        }
        if (ownedOfferings[selectedClass.challengeId] || ownedChallenges[selectedClass.challengeId]) {
            viewModel.priceText = ""
            viewModel.showClassLocation = true
            viewModel.objectSnapshot = selectedClass
            viewModel.classId = selectedClass.id
            viewModel.payment = 0
            viewModel.agreeToTerms = true
        }
        if (reservationsMap[selectedClass.id]) {
            viewModel.userHasAlreadyReservedThisClass = true
            viewModel.showClassLocation = true
            viewModel.objectSnapshot = selectedClass
            viewModel.classId = selectedClass.id
        }

        if (selectedClass?.hostData) {
            extraDescription = selectedClass.hostData.map(val => {
                if (selectedInstructor?.studioMode || val.specialGuest) {
                    return (<div>
                        <div className="d-flex align-items-center">
                            <div className={"mb-2 mt-3 mr-2 " + (val.profileImageUrl ? "" : "d-none")} style={{height: '60px', width: '60px'}}>
                                <Image src={val.profileImageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                            </div>
                            <p className="mb-0 p-0 font-weight-bold">{val.name}</p>
                        </div>
                        <span className={(val.about ? "" : "d-none")}>
                            {val.about}
                        </span>
                    </div>)
    
                } else {
                    return (<div></div>)
                }
            })
        }
        // viewModel.showClassLocation = true
    }

    const handleReserveChallengeClass = () => {
        const purchase = ownedOfferings[selectedClass.challengeId] ?? ownedChallenges[selectedClass.challengeId]

        if (!purchase) {
            window.alert("You cannot reserve a spot for this class")
            return
        }

        console.log(purchase)
        const checkoutModel = {
            dropIn: false,
            purchaseId: purchase.id,
            type: "purchase",
            payment: 0
        }
        console.log(checkoutModel)
        const dataToCheckout = {
            ...checkoutModel,
            ...viewModel
        }
        checkoutHandler(dataToCheckout)
    }
    
    const { history, match } = props;

    const [formData, setFormData] = React.useState(null)

    function nextButtonClicked() {
        console.log("clicked next")

        if (viewModel.disableCheckout) {
            window.alert("disabled")
            return
        }
        // return
        // console.log(viewModel)
        if (!auth.userData) {
            window.alert("Must be logged in to book this class")
            return
        }

        if (viewModel.liabilityWaiverText && !viewModel.agreeToTerms) {
            window.alert("Must agree to liability waiver")
            return
        }

        var dataToCheckout = {
            ...checkoutModel,
            ...viewModel
        }

        if (formData) {
            dataToCheckout.formData = formData
        }
        // console.log(dataToCheckout)
        // return
        // window.alert("Wahoo!")
        checkoutHandler(dataToCheckout)
    }

    async function checkoutHandler(val) {

        setIsLoading(true)

        try {

            let paymentMethod = selectedPaymentMethod?.id
            // if (val.payment > 0) {
            if (val.showPayment) {
                
                if (!selectedPaymentMethod) { // requires payment with new card

                    const cardElement = elements.getElement(CardElement);

                    const paymentMethodReq = await stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement
                    }, {
                        stripeAccount: stripeAccountId
                    })
                    // console.log("paymentMethodReq: ", paymentMethodReq)
                    
                    if (paymentMethodReq.error?.message) {
                        await sendNewError(JSON.stringify({
                            error: paymentMethodReq.error.message,
                            location: "Creating payment method - ClassCheckout",
                            code: paymentMethodReq.error.code,
                            decline_code: paymentMethodReq.error.decline_code,
                            user: auth?.userData?.email,
                            host_name: selectedClass?.host_name,
                            classId: classID
                        }))
                        setIsLoading(false)
                        window.alert(paymentMethodReq.error.message)
                        return
                    }
                    
                    paymentMethod = paymentMethodReq?.paymentMethod?.id

                    if (val.type === "subscription") {
                        // setup card for future use.. 
                        //      Done server side
                    }
                }

            }

            // if (!paymentMethod) {
            //     window.alert("No payment method")
            // }

            var data = {
                ...val,
                // name: val.name,
                // description: `Class with ${val.instructorName}\n${val.timeString}`,
                // images: val.images,
                // runningTotal: Math.round(val.runningTotal * 100),
                paymentMethod: paymentMethod,
                willTakeOnPayment: val.takeonfee,
                agreeToBeContacted: val.marketingOptIn,
                userID: auth.userData.platformID,
                id: val.platformID,
                bookingType: "class",
                collection: "classes",
                bookingLocation: "widget",
                success_url: `${process.env.REACT_APP_BOOKING_SUCCESS_URL}${match.url}/confirm/${val.platformID}`,
                cancel_url: `${process.env.REACT_APP_BOOKING_CANCEL_URL}${match.url}/checkout/${val.platformID}`,
                customer_name: auth.userData.firstName,
                customer_email: auth.userData.email
            }

            // console.log("checkout data: ", data)
            // return 

            const response = await checkoutClass(data.id, data)
            if (!response.success) {
                await sendNewError(JSON.stringify({
                    error: response,
                    user: auth?.userData?.email,
                    host_name: selectedClass?.host_name,
                    classId: classID
                }))
                setIsLoading(false)
                if (response.message?.raw?.message) {
                    window.alert(response.message.raw.message)
                } else {
                    window.alert(response.message)    
                }
                
                return
            }

            const {sessionId, message, reservationId, connectAccountId, clientSecret, reservation} = response;

            if (sessionId) {
                setIsLoading(false)
                window.alert("We shouldn't be using sessionId anymore.. ")

            } else if (clientSecret) {

                // console.log(paymentMethodReq)

                const confirmedCardPayment = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: paymentMethod,
                    setup_future_usage: "off_session"
                }, {
                    stripeAccount: stripeAccountId
                })

                
                setIsLoading(false)
                if (confirmedCardPayment.error) {
                    await sendNewError(JSON.stringify({
                        message: confirmedCardPayment.error.message,
                        user: auth?.userData?.email,
                        host_name: selectedClass?.host_name,
                        classId: classID
                    }))
                    setIsLoading(false)
                    if (confirmedCardPayment.error.decline_code === 'do_not_honor') {
                        window.alert("Your card was declined due to the error `Do hot honor`. Please contact your bank to approve this charge and try again or use another card.")
                    } else {
                        window.alert(confirmedCardPayment.error.message)
                    }
                    return
                }
                
                handleSuccessfulPayment(data, reservationId, reservation)
            } else if (reservationId) {
                setIsLoading(false)
                handleSuccessfulPayment(data, reservationId, reservation)
            } else if (message) {
                await sendNewError(JSON.stringify({
                    message: message,
                    user: auth?.userData?.email,
                    host_name: selectedClass?.host_name,
                    classId: classID
                }))
                setIsLoading(false)
                
                window.alert(message)
            } else {
                setIsLoading(false)
                window.alert("Something went wrong after succesful api response")
            }
        } catch (err) {
            await sendNewError(JSON.stringify({
                error: err,
                user: auth?.userData?.email,
                host_name: selectedClass?.host_name,
                classId: classID
            }))
            setIsLoading(false)
            console.log("wuh oh")
            console.log(err)
            if (err.message) {
                window.alert(err.message)
            } else {
                window.alert(err)
            }
        }
    }

    function handleSuccessfulPayment(data, resId, reservation) {

        if (reservation) {
            dispatch(insertReservation({
                ...reservation,
                serverReservationObjectId: selectedClass.id
            }))
        }

        const analyticsData = {
            pixelId: selectedInstructor?.instructorProfile?.facebookPixelId,
            value: data.payment,
            name: data.name,
            classId: data.id,
            currency: 'USD',
            location: 'ClassCheckout',
            type: data.type, // pack, dropin, subscription
            offering: data?.offering?.name ?? 'none',
            offeringId: data?.offering?.id ?? 'none'
        }

        analytics.track("bookingSuccess", analyticsData)
        analytics.track('Purchase', analyticsData)

        if (selectedClass.challengeId) {
            return
        }

        const {match} = props
        console.log("match: ", match)
        var URL =  match.url.replace("checkout", "confirm")
        if (resId) {
            URL = URL + `?reservation_id=${resId}`
        }
        console.log("match: ", URL)
        history.push(URL)
    }

    const submit = (event) => {
        event.preventDefault();
        nextButtonClicked();
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })

    // console.log("checkout viewmodel: ", viewModel)

    const checkoutSection = (
        <>
        {viewModel.allowsBooking ? (
            <div className="m-auto" >
                {checkoutData && !viewModel.disableCheckout && (
                    <>
                    <Form.Group>
                        <OfferingSelector
                        {...checkoutData}
                        // onChange={(model) => console.log(`got the model: ${model}`)}
                        onChange={(model) => {
                            // console.log(model)
                            setCheckoutModel(model)
                        }}
                        />
                    </Form.Group>
                    <hr/>
                    </>
                )}

                <LoginSignupForm
                mode={'signin'}
                onComplete={() => "Logged in successfully"}
                />

                <div className='mt-3'>
                    <Form.Group>
                        {viewModel.liabilityWaiverText && (<>
                            <br></br>
                            <ExpandableTerms terms={viewModel.liabilityWaiverText} />
                            <Form.Check 
                            checked={agreeToTerms}
                            // className="primaryColor"
                            type="checkbox"
                            id="terms-checkbox"
                            onChange={(e) => setAgreeToTerms(e.target.checked)}
                            label={`I agree to the Liability Waiver`}
                        />
                        </>)}
                        {viewModel.showMarketingOptIn && (
                            <Form.Check 
                                checked={marketingEmails}
                                // className="primaryColor"
                                type="checkbox"
                                id="marketing-switch"
                                onChange={(e) => setMarketingEmails(e.target.checked)}
                                label={`I agree to receive newsletters + product updates from ${viewModel.partnerName}.`}
                            />
                        )}
                    </Form.Group>
                </div>
                {viewModel?.formResponse && viewModel.formResponse.fields?.length > 0 && (
                    <div className="mt-3">
                        <CustomFormFields formResponse={viewModel.formResponse} handleUpdate={setFormData} />
                        
                    </div>
                )}

                <hr/>
                {viewModel.showPayment && checkoutData?.paymentMethods && (
                    <Form.Group>
                        <PaymentMethodSelector
                        {...checkoutData}
                        paymentMethods={checkoutData.paymentMethods}
                        // onChange={(model) => console.log(`got the model: ${model}`)}
                        onChange={(model) => {
                            setSelectedPaymentMethod(model)
                        }}
                        />
                    </Form.Group>
                )}
                {viewModel.showPayment && !selectedPaymentMethod && (
                    <CardSection className="w-100 mb-5" />
                )}

                {checkoutData && checkoutModel && !viewModel.disableCheckout && (
                    <CheckoutPricingSection
                    checkoutData={checkoutData}
                    checkoutModel={checkoutModel}
                    handleCouponCodeChange={handleCouponCodeChange}
                    handleCouponCodeApply={handleCouponCodeApply}
                    isLoading={isLoading}
                    />
                )}
                
                <div className="d-flex flex-row justify-content-center">
                    <Button disabled={isLoading || viewModel.disableCheckout} onClick={() => nextButtonClicked()} style={{width: "50%"}} className="primaryColor my-4" variant="primary">
                        {viewModel.nextbuttonstring}
                        {isLoading && (
                            <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                            >
                                <span className="sr-only">Sending...</span>
                            </Spinner>

                        )}
                    </Button>
                </div>
            </div>

        ) : (
            <div className="text-center">
                <h4 className="mx-auto">This class has passed</h4>
                <div className="d-flex flex-row justify-content-center">
                    <Link className="btn btn-primary primaryColor my-4" to={`/${widget.widgetName}`} >
                        Browse Classes
                    </Link>
                </div>
                
            </div>
        )}
        </>
        )
    return (

        <Section
        textColor="dark"
        size="sm"
        className="text-left"
        >
            <div>
            {(selectedClass) ? (
                // <form onSubmit={submit}>
                <div>
                    {["Class", "Appointment"].includes(selectedClass.experience_type) && (
                    <>
                        <div className='d-flex d-column justify-content-between'>
                            <div>
                                <div className='d-flex d-column justify-content-between'>
                                    <h6 className="classTitle mb-1">{viewModel.name}</h6>
                                </div>
                                
                                <p className="my-0">{viewModel.timeString}</p>
                                <p className="my-0">with&nbsp;{viewModel.instructorName}</p>
                                <p className="my-0 font-weight-bold">{viewModel.location}</p>
                                <Accordion>
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                                        View Details
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <p style={{whiteSpace: "pre-line"}}>{viewModel.description}</p>
                                        {/* <div>{extraDescription}</div> */}
                                    </Accordion.Collapse>
                                </Accordion>
                            </div>
                            <div>
                                <h6 className="mb-1">{viewModel.priceText}</h6>
                                {viewModel.spotsLeft < 10 && (
                                    <p><small>{spotsLeftText}</small></p>
                                )}
                            </div>
                        </div>
                        <hr/>
                    </>
                    )}
                    {!["Class", "Appointment"].includes(selectedClass.experience_type) && (
                        <>
                            <PreviewImage imageUrl={viewModel.image} aspectPercentage={"45%"} className="mb-4" />
                            <div className='d-flex d-column justify-content-between'>
                                <h2 className="classTitle mb-1">{viewModel.name}</h2>
                                <div>
                                    <h6 className="mb-1">{viewModel.priceText}</h6>
                                    {viewModel.spotsLeft < 10 && (
                                        <p><small>{spotsLeftText}</small></p>
                                    )}
                                </div>
                                
                            </div>
                            <div className="mb-5">
                                <h5>{viewModel.location} | {viewModel.timeString}</h5>
                                <h6 style={{whiteSpace: "pre-line"}}>{viewModel.description}</h6>
                            </div>
                        </>
                    )}
                    {/* // JARCH start */}
                    {/* {viewModel.userHasAlreadyReservedThisClass ? ( */}
                    {viewModel.showClassLocation ? (
                        <Section
                        className="mt-4"
                        >
                            <ClassLocationSection 
                            value={viewModel.objectSnapshot}
                            // value={selectedClass}
                            classId={viewModel.classId}
                            reserved={viewModel.userHasAlreadyReservedThisClass}
                            onReserveClass={handleReserveChallengeClass}
                            isLoading={isLoading}
                            />

                            {selectedClass?.onDemand?.downloadUrl && (
                                <div className="embed-responsive embed-responsive-16by9">
                                    <iframe className="embed-responsive-item" src={selectedClass.onDemand.downloadUrl} allowFullScreen={true} ></iframe>
                                </div>
                            )}

                        </Section>
                    ) : (
                        <>
                            {checkoutSection}
                        </>
                    )}
                    {/* // JARCH end */}
                </div>
            ) : (
            <>
                <div className='align-self-stretch container text-center my-auto pt-5'>
                    <Spinner className='mt-5' animation="grow"/>
                </div>
            </>

                
            )}
        </div>
        </Section>
    );
}

function ExpandableTerms({terms}) {

    const isLong = terms.length > 160

    const [expanded, setExpanded] = React.useState(false)

    const reactElement = terms ? htmlToReactParser.parse(terms) : terms;
    const shortenedReactElement = isLong ? htmlToReactParser.parse(terms.substring(0,119)) : reactElement

    return (<div className="mb-3">
        <Modal className="w-100" show={expanded} onHide={() => setExpanded(false)} centered>
            <Modal.Header closeButton>
                Liability Waiver
            </Modal.Header>
            <Modal.Body className="primary-background">
                {/* {terms} */}
                {reactElement}
            </Modal.Body>
            
        </Modal>
        <h3>Liability Waiver</h3>
        
        {isLong ? (
            // <span>{terms.substring(0,119)}<button className="p-0 btn btn-link primaryColor" onClick={() => setExpanded(true)}>Read more</button></span>
            <span>{shortenedReactElement}<button className="p-0 btn btn-link primaryColor" onClick={() => setExpanded(true)}>Read more</button></span>
        ) : (
            <span>{reactElement}</span>
        )}
    </div>)
}

export {ExpandableTerms}

export default ClassCheckout;
